import LoadingIndicator from './loading-indicator';

export default LoadingIndicator;